import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

import OperatorApplicationSuggestedTemplate
    from "~/operatorApplication/vue/dialogs/dialog/suggestedTemplates/OperatorApplicationSuggestedTemplate.vue";
import {inject} from "vue";
import {TextareaButtonInjectionKey} from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import OperatorApplicationSuggestedTemplatesWrapper
    from "~/operatorApplication/vue/dialogs/dialog/suggestedTemplates/OperatorApplicationSuggestedTemplatesWrapper.vue";


const __default__ = {
    name: "OperatorApplicationSuggestedTemplates"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {
    suggestedTemplates,
    selectedSuggestedTemplate,
    client,
    setSuggestedTemplates,
    onSuggestedTemplateSelect
} = inject(TextareaButtonInjectionKey);

return (_ctx: any,_cache: any) => {
  return (_unref(suggestedTemplates).length)
    ? (_openBlock(), _createBlock(OperatorApplicationSuggestedTemplatesWrapper, { key: 0 }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(suggestedTemplates), (template, key) => {
            return (_openBlock(), _createBlock(OperatorApplicationSuggestedTemplate, {
              key: key,
              template: template,
              "site-id": _unref(client).siteId,
              onSelect: _cache[0] || (_cache[0] = ($event: any) => (_unref(onSuggestedTemplateSelect)($event))),
              selected: template === _unref(selectedSuggestedTemplate),
              onReload: _unref(setSuggestedTemplates)
            }, null, 8, ["template", "site-id", "selected", "onReload"]))
          }), 128))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})